<div doc-viewer style="display: flex; height: 100%; flex-direction: column">
  <lex-doc-viewer-action-bar></lex-doc-viewer-action-bar>
  <div style="display: flex; height: 100%; overflow-y: hidden; overflow-x: auto;">
    <lex-doc-viewer-context-panel [panelWidth]="menuResizer.menuWidth"></lex-doc-viewer-context-panel>
    <div class="grip-handle" style="flex: 0 0 5px;"
         [ngClass]="{'disable-mouse-events' : menuResizer.menuWidth <= leftPanelCollapseWidth}"
         (mousedown)="onMenuResize($event)"></div>
    <div style="display: flex; flex-direction: column; overflow: hidden; width: 100%; margin: 0 0 0 5px;">
      <lex-doc-viewer-content></lex-doc-viewer-content>
      <lex-doc-viewer-bottom-panel></lex-doc-viewer-bottom-panel>
    </div>
    <lex-doc-viewer-right-panel></lex-doc-viewer-right-panel>
  </div>
</div>
